import { render } from "./category.vue?vue&type=template&id=3754268e&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"

import "./category.vue?vue&type=style&index=0&id=3754268e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3754268e"

export default script